import { TbBatteryCharging2 } from "react-icons/tb";
import { LuBicepsFlexed } from "react-icons/lu";
import { IoColorPaletteOutline, IoWaterOutline } from "react-icons/io5";
import { MdOutlinePermDeviceInformation } from "react-icons/md";
import { GiNetworkBars } from "react-icons/gi";
import { GrDocumentVerified } from "react-icons/gr";
import { FaMobileScreen } from "react-icons/fa6";
import { FaCheck, FaMobileAlt, FaBoxOpen } from "react-icons/fa";

export const getAttributeQuestionAnswer = (product, questionName) => {
  if (!product?.attributeQuestion) return null;
  const question = product.attributeQuestion.find(
    (q) => q.questionId?.question?.toLowerCase() === questionName?.toLowerCase()
  );
  return question ? question.answer : null;
};

export const getAttributeValue = (product, keyName) => {
  if (!product?.attributes) return null;
  const attr = product.attributes.find(
    (attr) => attr.key?.name?.toLowerCase() === keyName?.toLowerCase()
  );
  return attr ? attr.value?.value : null;
};

export function getQualityReportItems(product) {
  return [
    {
      icon: <FaCheck className="text-emerald-500" size={10} />,
      label: "Category",
      value: product?.category?.name || undefined,
    },
    {
      icon: <FaCheck className="text-emerald-500" size={10} />,
      label: "Brand",
      value: product?.brand?.name || undefined,
    },
    {
      icon: <FaCheck className="text-emerald-500" size={10} />,
      label: "City",
      value: product?.city || undefined,
    },
    {
      icon: <IoColorPaletteOutline className="text-indigo-500" />,
      label: "Color",
      value: getAttributeQuestionAnswer(product, "Colour :") || undefined,
    },
    {
      icon: <GrDocumentVerified className="text-indigo-500" />,
      label: "Under Brand Warranty?",
      value:
        getAttributeQuestionAnswer(product, "Under Brand Warranty ? :") ||
        undefined,
    },
    {
      icon: <FaMobileScreen className="text-indigo-500" />,
      label: "Screen Type",
      value: getAttributeQuestionAnswer(product, "Screen Type") || undefined,
    },
    {
      icon: <GiNetworkBars className="text-indigo-500" />,
      label: "Network Compatibility",
      value: getAttributeValue(product, "Network Compatibility") || undefined,
    },
    {
      icon: <MdOutlinePermDeviceInformation className="text-indigo-500" />,
      label: "Origin",
      value: getAttributeValue(product, "Device Origin :") || undefined,
    },
    {
      icon: <LuBicepsFlexed className="text-green-500" />,
      label: "Battery Health (%)",
      value:
        getAttributeQuestionAnswer(product, "Battery Health (%) : ") ||
        undefined,
    },
    {
      icon: <TbBatteryCharging2 className="text-red-500" />,
      label: "Battery Cycle count",
      value:
        getAttributeQuestionAnswer(product, "Battery Cycle Count :") ||
        undefined,
    },
    {
      icon: <FaMobileAlt className="text-blue-500" />,
      label: "Physical condition",
      value: getAttributeValue(product, "Physical condition") || undefined,
    },
    {
      icon: <FaBoxOpen className="text-orange-500" />,
      label: "Original Box?",
      value: getAttributeQuestionAnswer(product, "Original Box :") || undefined,
    },
    {
      icon: <IoWaterOutline className="text-cyan-500" size={20} />,
      label: "Waterproof?",
      value:
        getAttributeQuestionAnswer(product, "is Device Waterproof ?") ||
        undefined,
    },
    {
      icon: <FaCheck className="text-emerald-500" />,
      label: "Issue With Device",
      value:
        getAttributeQuestionAnswer(product, "Issues with Device :") ||
        undefined,
    },
    {
      icon: <FaCheck className="text-emerald-500" />,
      label: "Physical Condition",
      value:
        getAttributeQuestionAnswer(product, "Physical Condition :") ||
        undefined,
      fullWidth: true,
    },
    {
      icon: <FaCheck className="text-emerald-500" />,
      label: "Accessories with device",
      value:
        getAttributeQuestionAnswer(product, "Accessories with Device :") ||
        undefined,
      fullWidth: true,
    },
  ];
}
